import { render, staticRenderFns } from "./HStatsCard.vue?vue&type=template&id=bcdd25f4&"
import script from "./HStatsCard.vue?vue&type=script&lang=js&"
export * from "./HStatsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports